import { palette, Button, mediaQueries } from '@centivo/react-components'
import styled from 'styled-components'

export const NoResultsContainer = styled.div`
  display: grid;
  grid-column-gap: 1.25rem;
  min-height: 60vh;
  width: 100vw;
  grid-template-columns: 100%;
  grid-template-rows: min-content min-content min-content;
  padding: 0;

  @media ${mediaQueries.desktop} {
    grid-template-columns: 6fr 2fr 4fr;
    grid-template-rows: min-content;
    padding: 0.75rem 8rem;
  }
`
export const TitleContainer = styled.div`
  grid-column: 1 / span 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: ${palette.neutral['grey-f6f7fa']};
  padding: 1rem 2.5rem;
  margin: -3px -15px 0.5rem 0;
  width: 100vw;

  @media ${mediaQueries.desktop} {
    background-color: ${palette.neutral.white};
    padding: 0;
    width: 100%;
  }
`
export const NoResultsBold = styled.span`
  font-weight: bold;
  margin-right: 0.25rem;
  word-wrap: break-word;
  word-break: keep-all;

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return {
          color: theme.palette.brand.darkGray,
          fontSize: '1rem',
        }
      default:
        return {
          color: theme.palette.brand.darkGray,
          fontSize: '1.1rem',
        }
    }
  }}
`
export const FilterRangeText = styled(NoResultsBold)`
  font-weight: normal;
`
export const SuggestionText = styled(FilterRangeText)`
  font-size: 1rem;
  grid-column: 1;
  grid-row: 3 / span 1;
  padding: 0 2.5rem;

  @media ${mediaQueries.desktop} {
    grid-row: 2;
    padding: 0;
  }
`
export const FilterButton = styled(Button).attrs(props => ({
  ...props,
  buttonType: 'secondary',
  edgeType: 'rounded',
  slim: true,
}))`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-color: ${palette.neutral['grey-bbbdbf']};
  color: ${palette.neutral['grey-icons']};
  font-size: 16px;
  font-weight: 600;
  padding: 0.375rem 1rem;
  width: min-content;
  height: min-content;
  grid-column: 1;
  grid-row: 2 / span 1;
  margin: 1rem 2.5rem;

  &:hover {
    background-color: ${palette.neutral['grey-ebebeb']};
    box-shadow: none;
  }

  &:focus {
    background-color: ${palette.neutral['grey-ebebeb']};
  }

  @media ${mediaQueries.desktop} {
    grid-column: 2;
    grid-row: 1;
    margin: 0;
  }
`
